import _ from 'underscore';
import { BaseSchemaProcessor } from './base-schema-processor';
import { updateDeliveryStatusPropertyForFilter } from '../util/update-delivery-status-property-for-filter';
import { updateAuctionInsightPropertyForFilter } from '../util/update-auction-insight-property-for-filter';
import { updateEntitySchemaForTrackingUrlTemplate } from '../util/update-tracking-template-property-for-filter';
import { updateOdataOptionsForFinalUrl, updateEntitySchemaForFinalUrls } from '../util/update-final-url-property-for-filter';
import { updateEntitySchemaForFinalURLSuffix } from '../util/update-final-url-suffix-property-for-filter';
import { addCampaignTypePropertyForFilter } from '../util/update-campaign-type-property-for-filter';
import { updateEditorialRejectionReasonForFilter } from '../util/update-editorial-rejection-reason-for-filter';
import { initialize as initializeIsAppealPending, updateEntitySchemaForIsAppealPending } from '../util/update-is-appeal-pending-property-for-filter';
import { updateStatusPropertyForFilter } from '../util/update-status-property-for-filter';

export class KeywordSchemaProcessor extends BaseSchemaProcessor {
  constructor(options) {
    super(options);
    initializeIsAppealPending(options);

    this.enableEditorialRejectionFilter = options.enableEditorialRejectionFilter;
  }

  updateEntitySchemaForFeatures(entitySchema) {
    const updatedSchema = super.updateEntitySchemaForFeatures(entitySchema);

    const campaignNameProperty = updatedSchema.properties.CampaignName;
    campaignNameProperty.title = this.i18n.getString('FilterLocalization_DataAttribute_CampaignName');

    const adgroupNameProperty = updatedSchema.properties.AdGroupName;
    adgroupNameProperty.title = this.i18n.getString('FilterLocalization_DataAttribute_AdGroupName');

    const deliveryStatusEnumSet = ['NegativeKeywordConflicts',
      'PartialNegativeKeywordConflicts',
      'EditorialApprovedLimited',
      'LowSupply',
      'LowQuality',
      'BidBelowFirstPageBid',
      'CampaignBudgetPaused',
      'CampaignUserPaused',
      'AdGroupExpired',
      'EditorialRejected',
      'CampaignSuspended',
      'AdGroupDraft',
      'EditorialUnderAppeal',
      'EditorialPending',
      'AdGroupUserPaused',
      'InvalidFinancialStatusOther',
      'Eligible',
    ];

    if (this.Permissions && this.Permissions.dynamic && this.Permissions.dynamic.AppealUpheld) {
      deliveryStatusEnumSet.splice(deliveryStatusEnumSet.indexOf('EditorialApprovedLimited') + 1, 0, 'EditorialApprovedLimitedAppealRejected');
      deliveryStatusEnumSet.splice(deliveryStatusEnumSet.indexOf('EditorialRejected') + 1, 0, 'EditorialAppealRejected');
    }

    updateStatusPropertyForFilter(entitySchema);

    updateDeliveryStatusPropertyForFilter(entitySchema, deliveryStatusEnumSet);

    updateAuctionInsightPropertyForFilter(entitySchema);

    updateEntitySchemaForFinalUrls(entitySchema);

    updateEntitySchemaForTrackingUrlTemplate(entitySchema);

    updateEntitySchemaForFinalURLSuffix(entitySchema);

    // make campaignstatus and adgroupproperty not show in filter drop down
    const campaignStatusProperty = updatedSchema.properties.CampaignStatus;
    const adgroupStatusProperty = updatedSchema.properties.AdGroupStatus;

    if (campaignStatusProperty) {
      campaignStatusProperty.filterable = false;
    }

    if (adgroupStatusProperty) {
      adgroupStatusProperty.filterable = false;
    }

    updateEditorialRejectionReasonForFilter({
      entitySchema: updatedSchema,
      enableEditorialRejectionFilter: this.enableEditorialRejectionFilter,
      i18n: this.passedInI18n,
    });

    if (!this.isForVNext) {
      if (updatedSchema.properties.EditorialStatus) {
        updatedSchema.properties.EditorialStatus.filterable = false;
      }
    }
    // only enable it on new ui
    if (this.isForVNext) {
      updateEntitySchemaForIsAppealPending(updatedSchema);
    }

    if (this.isForVNext) {
      const campaignTypeNotSupported = ["Enum.CampaignType'PerformanceMax'", "Enum.CampaignType'LinkedIn'"];
      addCampaignTypePropertyForFilter({
        entitySchema: updatedSchema, permissions: this.Permissions, campaignTypeNotSupported,
      });
    }

    const matchTypesToExclude = ["Enum.MatchType'Content'"];
    const isPredictiveTargetingEnabled = this.Permissions && this.Permissions.dynamic && this.Permissions.dynamic.RSABidStrategyAutoTargeting;
    const isPredictiveMatchingEnabled = this.Permissions && this.Permissions.dynamic && this.Permissions.dynamic.PredictiveMatching;
    if (!isPredictiveTargetingEnabled && !isPredictiveMatchingEnabled) {
      matchTypesToExclude.push("Enum.MatchType'Predictive'");
    }

    updatedSchema.properties.MatchType.enum = _.without(updatedSchema.properties.MatchType.enum, ...matchTypesToExclude);

    return updatedSchema;
  }

  updateOdataOptions(odataOptions) {
    super.updateOdataOptions(odataOptions);
    updateOdataOptionsForFinalUrl(odataOptions);

    return odataOptions;
  }
}
